// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectLanguage_root__jzWyK"};